import type { ReactNode } from 'react';

export interface SectionCardProps {
  /** Id for the heading, referenced by aria-labelledby. */
  headingId: string;
  title: string;
  count?: number;
  description?: string;
  action?: ReactNode;
  children: ReactNode;
}

export function SectionCard({ headingId, title, count, description, action, children }: SectionCardProps) {
  return (
    <section className="card overflow-hidden" aria-labelledby={headingId}>
      <div className="card-header">
        <div className="min-w-0">
          <h2 id={headingId} className="flex items-center gap-2 text-sm font-semibold text-slate-900">
            {title}
            {typeof count === 'number' ? (
              <span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-600 tabular-nums">
                {count}
              </span>
            ) : null}
          </h2>
          {description ? <p className="mt-0.5 text-xs text-slate-500">{description}</p> : null}
        </div>
        {action ? <div className="flex shrink-0 items-center gap-2">{action}</div> : null}
      </div>
      {children}
    </section>
  );
}
